import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useCallback } from 'react';
import useAlert from './useAlert';
import useVerify from './useVerify';

const useAccount = () => {
	const { sendAlert } = useAlert();
	const { sendVerify } = useVerify();

	const navigate = useNavigate();

	const login = useCallback((form, back_url) => {
		axios.post('/user/auth/login', form).then((response) => {
			const message = response.data.message;
			const data = response.data.data;
			if (message === 'success') {
				// console.log(data)
				localStorage.setItem('token', data.token);
				localStorage.setItem('accountId', data.accountId);
				localStorage.setItem('walletAddress', data.walletAddress);
				localStorage.setItem('accountRole', data.role);
				localStorage.setItem('accountEmail', data.accountEmail);
				navigate(back_url);
			}
		}).catch((error) => {
			const message = error.response.data.message;
			switch (message) {
				case 'User not found':
					sendAlert('查無使用者');
					break;

				case 'Invalid password':
					sendAlert('密碼錯誤');
					break;

				case 'Please verify your account first':
					const accountId = error.response.data.data.accountId;
					sendVerify({
						title: '請先驗證您的電子信箱', 
						message: accountId, 
					});
					break;

				default:
					sendAlert('Oops!', '目前無法登入, 請稍後再試');
					break;
			}
		});
	}, [navigate, sendAlert]);

	const logout = useCallback(() => {
		localStorage.removeItem('token');
		localStorage.removeItem('accountId');
		localStorage.removeItem('walletAddress');
		localStorage.removeItem('accountRole');
		localStorage.removeItem('accountEmail');
		navigate('/');
	}, [navigate]);

	return { login, logout };
}

export default useAccount;